import { AnimationOverlay } from "./AnimationOverlay";
import type { OverlayConfig } from "../types/narrative";

interface AnimationOverlaysProps {
  overlay: OverlayConfig | OverlayConfig[] | undefined;
  keyPrefix?: string;
  className?: string;
}

/**
 * Renders one or more AnimationOverlay components.
 * Accepts either a single OverlayConfig or an array of OverlayConfigs.
 *
 * When multiple overlays are provided:
 * - They render in array order (first = bottom layer, last = top layer)
 * - Each overlay's zIndex property controls its stacking within the group
 * - Lower zIndex values appear behind higher values
 */
export function AnimationOverlays({
  overlay,
  keyPrefix = "overlay",
  className,
}: AnimationOverlaysProps) {
  if (!overlay) {
    return null;
  }

  // Normalize to array format for consistent handling
  const overlays = Array.isArray(overlay) ? overlay : [overlay];

  return (
    <>
      {overlays.map((config, index) => (
        <AnimationOverlay
          key={`${keyPrefix}-${index}`}
          config={config}
          className={className}
        />
      ))}
    </>
  );
}
